import { useTranslation } from 'react-i18next';

// Supported interface languages (each has a translation file in src/i18n/locales).
const UI_LANGUAGES: Array<{ code: string; label: string }> = [
  { code: 'en', label: '🇬🇧 English' },
  { code: 'ru', label: '🇷🇺 Русский' },
  { code: 'uk', label: '🇺🇦 Українська' },
  { code: 'es', label: '🇪🇸 Español' },
  { code: 'de', label: '🇩🇪 Deutsch' },
  { code: 'fr', label: '🇫🇷 Français' },
  { code: 'zh', label: '🇨🇳 中文' },
  { code: 'pt', label: '🇧🇷 Português' },
];

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const current = (i18n.language || 'en').split('-')[0];

  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
      <span aria-hidden="true" style={{ fontSize: '1.2rem' }}>🌐</span>
      <span className="sr-only">{t('nav.interfaceLanguage')}</span>
      <select
        value={UI_LANGUAGES.some((l) => l.code === current) ? current : 'en'}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        aria-label={t('nav.interfaceLanguage')}
        style={{
          padding: '0.5rem 0.75rem',
          background: 'rgba(99, 102, 241, 0.2)',
          border: '1px solid rgba(99, 102, 241, 0.3)',
          borderRadius: '10px',
          color: '#e2e8f0',
          cursor: 'pointer',
          fontSize: '0.9rem',
          fontWeight: 600,
          outline: 'none',
        }}
      >
        {UI_LANGUAGES.map((l) => (
          <option key={l.code} value={l.code} style={{ background: '#1a1a2e', color: '#e2e8f0' }}>
            {l.label}
          </option>
        ))}
      </select>
    </label>
  );
}
